import { DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY } from 'components/discover/shared';
import type { FetchStatus } from 'hooks/useFetchData';
import { FC } from 'react';

import { ErrorWithRetry } from '../../shared/ErrorWithRetry';
import type { MostViewedResearchItem } from './model';
import { PopularResearch } from './presentation/PopularResearch';
import { PopularResearchSkeleton } from './skeletons';

interface PopularResearchContainerProps {
  status: FetchStatus;
  items: Nullable<ReadonlyArray<MostViewedResearchItem>>;
  retry: Nullable<() => void>;
  className?: string;
}
export const PopularResearchContainer: FC<PopularResearchContainerProps> = ({ status, items, retry, className }) => {
  if (status === 'empty') {
    return null;
  }
  if (status === 'unauthorized') {
    throw new Error('Unauthorized for Insight/Research');
  }

  return (
    <>
      {status === 'loading' && <PopularResearchSkeleton count={10} className={className} />}
      {status === 'success' && <PopularResearch data={items!} className={className} />}
      {status === 'error' && (
        <ErrorWithRetry onRetry={retry} e2e="popular-research-error" msgKey={DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY} />
      )}
    </>
  );
};
